const initialvalues = {
        year: "",
        gen_voc: "",
        exam_scedule_code: "",
        dist_code: "",
        coll_code: "",
        title: "",
        title_course: "",
        calender_title: "",
        course_code: "",
        prev_flag: "N",
        topic_array: [],
        sub_code: {},
        topic_arrays: [],
        datachapterno: {},
        backdatareducer: {},
        backreducerData: []


        
};

export default function AcStudentsMarksCourseReducer(details = initialvalues, action) {

        switch (action.type) {
                case "YEAR":
                        return { ...details, year: action.payload };
                case "GEN_VOC":
                        return { ...details, gen_voc: action.payload };
                case "DIST_CODE":
                        return { ...details, dist_code: action.payload };
                case "COLL_CODE":
                        return { ...details, coll_code: action.payload };
                case "EXAM_SCEDULE_CODE":
                        return { ...details, exam_scedule_code: action.payload };
                case "BACKDATAREDUCER":
                        return { ...details, backdatareducer: action.payload };
                case "TITLE":
                        return { ...details, title: action.payload };
                case "TITLE_COURSE":
                        return { ...details, title_course: action.payload };
                case "CALENDER_TITLE":
                        return { ...details, calender_title: action.payload };
                case "COURSE_CODE":
                        return { ...details, course_code: action.payload };
                case "PREV_FLAG":
                        return { ...details, prev_flag: action.payload };
                case "TOPIC_ARRAY":
                        return { ...details, topic_array: action.payload };

                case "SUBCODE":
                        return { ...details, sub_code: action.payload };
                case "TOPIC_ARRAYS":
                        return { ...details, topic_arrays: action.payload };
                case "DATACHAPTERNO":
                        return { ...details, datachapterno: action.payload };
                case "BACKREDUCERDATA":
                        return { ...details, backreducerData: action.payload };


                default:
                        return details;
        }
}